import setTopOfHtmlElementThroughStyle from "./setTopOfHtmlElementThroughStyle";

const animateSpinningOfTheOnlyOneCard = (element: any, options: any, extremeValue: number, isSpinningOnlyOne: boolean, verticalCardIndexOfSelectedRow: any) => {
    let choosenOption = options[extremeValue] as HTMLDivElement;

    if(choosenOption) {
        setTimeout( () => {
            choosenOption = options[verticalCardIndexOfSelectedRow.current] as HTMLDivElement;
            if (choosenOption)
                setTopOfHtmlElementThroughStyle(element, -choosenOption.offsetTop, isSpinningOnlyOne);
        }, 500);

        if (choosenOption)
            setTopOfHtmlElementThroughStyle (element, -choosenOption.offsetTop, isSpinningOnlyOne);
    }
}

export default animateSpinningOfTheOnlyOneCard;